import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-max-length",
  templateUrl: "./field-set-max-length.component.html",
  styles: [],
})
export class FieldSetMaxLengthComponent {
  @Input() public fieldOptions: any = {validate: {maxLength: 255}};
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
